import { MegaMenuNavigationItem } from '@layouts/MegaMenu/MegaMenu.types';
import React from 'react';

interface MainNavigationProps {
  model: MegaMenuNavigationItem[];
  onClick: (index: string) => void;
  selected: string;
}

export const MainNavigation = ({ model, selected, onClick }: MainNavigationProps) => {
  const handleClick = (index: string) => {
    onClick(index);
  };

  const setValue = (val: string) => {
    window.localStorage.setItem('menuContainerLink', val);
  };

  if (!model) return null;

  const itemClass = 'c-header-main-menu-item';

  return (
    <>
      {model.map((item, index) =>
        item.NoSubCategory ? (
          <a
            onClick={() => setValue(item.ContainerLink)}
            key={index}
            className={
              window.localStorage.getItem('menuContainerLink') == item.ContainerLink
                ? `${itemClass} active`
                : itemClass
            }
            href={item.UrlSegment}
          >
            {item.Name}
          </a>
        ) : (
          <button
            onClick={() => handleClick(item.ContainerLink)}
            key={index}
            className={selected === item.ContainerLink ? `${itemClass} active` : itemClass}
          >
            {item.Name}
          </button>
        )
      )}
    </>
  );
};
